module.exports = __webpack_public_path__ + "static/media/Workshop_DESIGN_THINKING.1375d026.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/designThings/Workshop_DESIGN_THINKING.png
// module id = 25
// module chunks = 0